import * as React from 'react';
import { Button } from 'react-bootstrap';

interface PaginationProps {
  page: number;
  pageSize: number;
  total?: number;
  currentPageCount?: number;
  disabled?: boolean;
  showNext?: boolean;
  keyNavigation?: boolean;
  listUrl?: string;
  onChangePage: (page: number) => void;
}

export const Pagination = ({
  page,
  pageSize,
  total,
  currentPageCount,
  disabled = false,
  showNext = true,
  keyNavigation = false,
  listUrl,
  onChangePage
}: PaginationProps) => {
  const start = (( page - 1) * pageSize ) + 1;
  let end = 0;
  let lastPage = 1;
  let totalDesc = '';

  // If the total is unknown, use the current page's record count to guess
  if (total == null) {
    if (currentPageCount == null) {
      throw new Error('If the total is unknown, the current page\'s record count should be provided');
    }

    end = start + currentPageCount - 1;
    lastPage = currentPageCount < pageSize ? page : page + 1;
  } else {
    end = start + pageSize > total ? total : start - 1 + pageSize;
    lastPage = Math.ceil(total / pageSize);
    totalDesc = ` of ${total.toLocaleString('en-US')}`;
  }

  const description = `${start} ${pageSize > 1 && end > start ? `- ${end}` : ''}${totalDesc}`;

  return (
    <div className="Pagination">
      <ul className="list-inline">
        <li>
          <Button
            bsSize="large"
            disabled={disabled || page <= 1}
            onClick={() => onChangePage(page - 1)}
            title={keyNavigation ? 'Press ←' : ''}
            aria-label="Previous page"
          >
            <i className="fa fa-chevron-left"/>
          </Button>
        </li>
        <li>
          { listUrl ?
            ( <a href={listUrl}>{description}</a> ) :
            ( <span className="text-muted">{description}</span> )
          }
        </li>
        <li>
          <Button
            bsSize="large"
            disabled={disabled || page === lastPage}
            onClick={() => onChangePage(page + 1)}
            title={keyNavigation ? 'Press →' : ''}
            aria-label="Next page"
          >
            <i className="fa fa-chevron-right"/>
          </Button>
        </li>
      </ul>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Pagination/Pagination.tsx